import  { FunctionComponent } from "react"


interface IParameters {
    employeeId: string;
}
const UndefinedIdentity: FunctionComponent<IParameters> = (props) => {

    return props.employeeId ?
        props.children : <div>Önce kimlik kaydını tamamlayınız.</div>
}

export default UndefinedIdentity;